import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {CallJs} from "../lib/types";

type FormButtonsCallJsParams = {
	form: string
	enableCancel?: boolean
	cancel_label: string
	cancel: string
	single: number|string
	save_label: string
	command_value: string
}

type FormButtonsProps = {
	command_value: string
	form: string
	enableCancel: boolean
	cancel_label: string
	cancel: (() => void)|undefined
	single: boolean
	save_label: string
}

export const form_buttons: CallJs<FormButtonsCallJsParams> = (replace, params) => {
	const div = document.createElement('div')
	div.id = `${params.form}_buttons`

	replace(div)

	const enableCancel: boolean = params.enableCancel === null || params.enableCancel === undefined ? true : params.enableCancel

	const p = {
		...params,
	}
	ReactDOM.render(
		<FormButtons
			{...params}
			enableCancel={enableCancel}
			cancel={params.cancel ? () => {eval(params.cancel)} : undefined}
			single={params.single==1 || params.single=="1"}
		/>, div)
}

export const FormButtons = (params: FormButtonsProps) => {
	return <table style={{width: "100%", border: "0"}} cellPadding={0} cellSpacing={0}>
		<tbody>
		<tr>
			{params.enableCancel && <td>
				<input type="button" name="cancel" value={params.cancel_label} className="submit" onClick={params.cancel} />
			</td>}
			<td style={{textAlign: "right"}}>
				<input type="submit"
					name="submit_page"
					value={params.save_label}
					className="submit"
					 />
				{!params.single &&
					<input type="submit"
						name="submit_page"
						value="Save / Return"
						className="submit"
						onClick={() => {document.forms.namedItem(params.form)['command'].value = params.command_value }}
						/>
					}
					</td>
					</tr>
		</tbody>
	</table>
}





// WEBPACK FOOTER //
// ./src/legacy/form-buttons.tsx